var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5456 5.11097C22.1314 5.69676 22.1314 6.6465 21.5456 7.23229L10.3026 18.4753C9.67779 19.1001 8.66473 19.1001 8.03989 18.4753L2.45375 12.8891C1.86796 12.3034 1.86796 11.3536 2.45375 10.7678C3.03953 10.182 3.98928 10.182 4.57507 10.7678L9.17126 15.364L19.4243 5.11097C20.0101 4.52518 20.9599 4.52518 21.5456 5.11097Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckFill);
export default __webpack_public_path__ + "static/media/check_fill.7a21eb3afffa6715e18e77a8be84c6d8.svg";
export { ForwardRef as ReactComponent };